module.exports = __webpack_public_path__ + "static/media/slide_3.f97c1d20.jpg";